import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock } from 'lucide-react';
import { Button } from './ui/Button';
import { CountdownTimer } from './CountdownTimer';
import { trackAddToCart } from '../utils/metaPixel';
const includes = [{
  text: <>Ebook "PNM: CONTROL TOTAL" - Dura Más en la Cama en Semanas</>,
  value: '$19.990'
}, {
  text: <>
        BONUS #1: "Hazla Venir con Tu Lengua" -{' '}
        <strong className="text-brand-gold" data-id="element-99">Técnica lésbica secreta</strong>
      </>,
  value: '$19.990'
}, {
  text: <>
        BONUS #2: "El Código del Placer Femenino" - Mapa completo de sus zonas
      </>,
  value: '$19.990'
}, {
  text: <>BONUS #3: "Cómo Usar Tus Dedos" - Técnicas avanzadas</>,
  value: '$19.990'
}, {
  text: <>
        Acceso inmediato - Descarga en{' '}
        <strong className="text-white" data-id="element-100">2 minutos</strong>
      </>,
  value: ''
}];
export function FinalOffer() {
  return <section id="oferta" className="py-16 px-4 bg-black relative border-t border-brand-red/30 overflow-hidden" data-id="element-101">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[500px] bg-brand-red/10 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-102" />

      <div className="max-w-4xl mx-auto" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-104">
          <span className="text-6xl mb-6 block" data-id="element-105">🔥</span>

          <p className="text-2xl text-white font-bold" data-id="element-106">
            Resumen de todo lo que te llevas hoy!
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-card border-2 border-brand-red/50 rounded-3xl p-8 md:p-12 mb-10 relative shadow-2xl shadow-brand-red/10" data-id="element-107">
          <div className="w-full max-w-lg mx-auto rounded-2xl mb-8 overflow-hidden" data-id="element-108">
            <img src="https://cdn.magicpatterns.com/uploads/vX36rNPvjngAV69fo1986v/Copia_de_2B4_BONOS_SOLO_HOY_(2).png" alt="PNM: Control Total + Bonuses" className="w-full h-auto object-contain" data-id="element-109" />
          </div>

          <div className="space-y-4 mb-8" data-id="element-110">
            {includes.map((item, index) => <div key={index} className="flex items-start gap-4 p-3 rounded-lg hover:bg-white/5 transition-colors" data-id="element-111">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-112" />
                <div className="flex-1" data-id="element-113">
                  <p className="text-gray-200" data-id="element-114">{item.text}</p>
                  {item.value && <p className="text-sm text-gray-500" data-id="element-115">Valor: {item.value}</p>}
                </div>
              </div>)}
          </div>

          <div className="border-t border-gray-800 pt-8 mb-8 text-center" data-id="element-116">
            <p className="text-gray-400 text-xl mb-2" data-id="element-117">
              VALOR TOTAL: <span className="line-through" data-id="element-118">$79.960</span>
            </p>
            <p className="text-4xl md:text-6xl font-oswald text-white mb-4" data-id="element-119">
              PRECIO ESPECIAL HOY:{' '}
              <span className="text-brand-gold font-bold bg-brand-gold/10 px-2 rounded" data-id="element-120">
                $17.900
              </span>
            </p>
            <div className="inline-block bg-green-500/10 text-green-500 border border-green-500/30 px-6 py-2 rounded-full font-bold animate-pulse" data-id="element-121">
              AHORRÁS: $62.060 (78% DE DESCUENTO)
            </div>
            <div className="mt-4 inline-block bg-brand-gold/10 text-brand-gold border border-brand-gold/30 px-6 py-2 rounded-full font-bold text-lg tracking-wide" data-id="element-122">
              💳 3 CUOTAS SIN INTERÉS
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-123">
            <p className="text-brand-red font-bold uppercase tracking-widest mb-4 flex items-center justify-center gap-2" data-id="element-124">
              <span className="w-2 h-2 rounded-full bg-brand-red animate-pulse" data-id="element-125" />
              ESTA OFERTA EXPIRA EN:
              <span className="w-2 h-2 rounded-full bg-brand-red animate-pulse" data-id="element-126" />
            </p>
            <CountdownTimer data-id="element-127" />
          </div>

          <div className="text-center" data-id="element-128">
            <Button className="mb-6" onClick={() => {
            trackAddToCart();
            window.location.href = 'https://templodigital.shop/cart/42704248045639:1';
          }} data-id="element-129">
              AGREGAR AL CARRITO
            </Button>
            <div className="flex items-center justify-center gap-2 text-gray-400 text-sm" data-id="element-130">
              <Lock className="w-4 h-4" data-id="element-131" />
              <span data-id="element-132">Pago 100% Seguro y Anónimo - Acceso Inmediato</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}